import { app } from '../../../../../../app';
import { Controller } from './idp-authenticator-applications-assign.controller';

app.component('companyIdpAuthenticatorsManageApplicationsAssign', {
    bindings: {
        companyId: '<',
        idpAuthenticator: '<',
        applications: '<',
    },
    controller: Controller,
    templateUrl: require('./idp-authenticator-applications-assign.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/applications/assign/idp-authenticator-applications-assign.component.js